import React from 'react';
import SectionShell from '../SectionShell';
import useAutoplayIntroVideo from '../../hooks/useAutoplayIntroVideo';

/**
 * Explainer video slide — sits DIRECTLY AFTER the Dual System
 * (dual-timeline) slide. Full-bleed, starts playing (muted) the moment
 * the slide enters the viewport; first tap unmutes.
 */
const VIDEO_SRC = '/videos/explainer-dual-system.mp4';

export default function SectionExplainer() {
  const { videoRef, stageRef } = useAutoplayIntroVideo('explainer');

  return (
    <SectionShell
      id="explainer"
      className="relative overflow-hidden"
      fullBleed
      centerContent
    >
      <div
        ref={stageRef}
        className="zert-video-stage"
        data-testid="explainer-stage"
      >
        <div className="zert-video-frame">
          <video
            ref={videoRef}
            className="zert-video-el"
            playsInline
            autoPlay
            preload="auto"
            poster="/videos/explainer-poster.jpg"
            data-testid="explainer-video"
          >
            <source src={VIDEO_SRC} type="video/mp4" />
          </video>
        </div>
      </div>
    </SectionShell>
  );
}
